import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Box,
  Grid,
  TextField,
} from "@mui/material";
import { AdminPageStyle } from "../../pages/admin/style";
import { addComma } from "../../common/services/number-service";

export const FleetInfo = ({
  companyNameHeader,
  state,
  fleetNo,
  fleetList,
  vehicleInfoValue,
  fuelListById,
  typeListById,
  setChecked,
  cycleYear,
  setVehicleInfoValue,
  setFleetNo,
  selectedRows,
}) => {
  const classes = AdminPageStyle();
  const handleFleetChange = (values, event) => {
    setChecked(new Array(cycleYear?.length).fill(false));
    let data = event;
    setFleetNo(data?.fleetId);
    let fleetData = fleetList?.find((item) => item?.fleetId == data?.fleetId);
    setVehicleInfoValue(fleetData);
  };

  return (
    <Grid item xs={12} sm={12} md={12} lg={6}>
      <Accordion
        defaultExpanded
        sx={(theme) => ({
          background: theme.palette.background.paper,
          border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(148,163,184,0.12)' : 'var(--divider)'}`,
          borderRadius: '16px !important',
          boxShadow: theme.palette.mode === 'dark' ? '0 8px 24px rgba(0,0,0,0.45)' : '0 8px 24px rgba(2, 6, 23, 0.06)',
          color: theme.palette.text.primary,
          '&:before': { display: 'none' },
        })}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: "var(--brand-primary)" }} />}
          aria-controls="panel1-content"
          id="panel1-header"
          className={classes.textGeneralInfo}
          sx={{ borderBottom: "1px solid var(--divider)", color: "var(--brand-primary)" }}
        >
          fleet information
        </AccordionSummary>
        <AccordionDetails sx={{ pt: 2 }}>
          <Box>
            <Box className={classes.divMt10}>
              <Box className={classes.fleetListGenInfoDiv}>
                <span className={classes.fleetListGenInfoTtext}>Company</span>
                <span className={classes.fleetListGenInfoInputText}>
                  {companyNameHeader?.companyName}
                </span>
              </Box>
            </Box>
            <Box className={classes.divMt10}>
              <Box className={classes.fleetListGenInfoDiv}>
                <span className={classes.fleetListGenInfoTtext}>Fleet</span>

                <Autocomplete
                  id="combo-box-demo"
                  disablePortal
                  disabled={(state?.data || selectedRows?.length > 1) ? true : false}
                  multiple={selectedRows?.length > 1}
                  defaultValue={selectedRows?.length > 1 ? selectedRows : fleetNo}
                  className={classes.textinput}
                  sx={{ width: selectedRows?.length > 1 ? "100%" : "148px !important" }}
                  onChange={handleFleetChange}
                  options={fleetList}
                  getOptionLabel={(option) => option?.fleetNo || ""}
                  renderInput={(params) => (
                    <TextField {...params} variant="standard" />
                  )}
                />
              </Box>
            </Box>
            <Box className={classes.divMt10}>
              <Box className={classes.fleetListGenInfoDiv}>
                <span className={classes.fleetListGenInfoTtext}>Age</span>
                <span className={classes.fleetListGenInfoInputText}>
                  {selectedRows?.length > 1 ? "" : vehicleInfoValue?.age}
                </span>
              </Box>
            </Box>
            <Box className={classes.divMt10}>
              <Box className={classes.fleetListGenInfoDiv}>
                <span className={classes.fleetListGenInfoTtext}>Fuel</span>
                <span>{selectedRows?.length > 1 ? "" : (vehicleInfoValue ? fuelListById?.name : "")}</span>
              </Box>
            </Box>
            <Box className={classes.divMt10}>
              <Box className={classes.fleetListGenInfoDiv}>
                <span className={classes.fleetListGenInfoTtext}>Type</span>
                <span>{selectedRows?.length > 1 ? "" : (vehicleInfoValue ? typeListById?.name : "")}</span>
              </Box>
            </Box>
            <Box className={classes.divMt10}>
              <Box className={classes.fleetListGenInfoDiv}>
                <span className={classes.fleetListGenInfoTtext}>Fleet Type</span>
                <span>{selectedRows?.length > 1 ? "" : (vehicleInfoValue ? (vehicleInfoValue?.fleetTypeId === 1 ? 'Government' : vehicleInfoValue?.fleetTypeId === 2 ? 'Corporate' : '') : '')}</span>
              </Box>
            </Box>
            <Box className={classes.divMt10}>
              <Box className={classes.fleetListGenInfoDiv}>
                <span className={classes.fleetListGenInfoTtext}>
                  CPM Category
                </span>
                <span>{selectedRows?.length > 1 ? "" : (vehicleInfoValue?.cpmCategory)}</span>
              </Box>
            </Box>
            <Box className={classes.divMt10}>
              <Box className={classes.fleetListGenInfoDiv}>
                <span className={classes.fleetListGenInfoTtext}>
                  Vehicle Total Miles
                </span>
                <span>
                  {selectedRows?.length > 1 ? "" : (addComma(Math.round(vehicleInfoValue?.totalMiles)))}
                </span>
              </Box>
            </Box>
            <Box className={classes.divMt10}>
              <Box className={classes.fleetListGenInfoDiv}>
                <span className={classes.fleetListGenInfoTtext}>
                  Vehicle Annual Mileage
                </span>
                <span>
                  {selectedRows?.length > 1 ? "" : (addComma(Math.round(vehicleInfoValue?.annualMileage)))}
                </span>
              </Box>
            </Box>
          </Box>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
};
